export default {
    list: (state) => state.list,
};
